// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { debounce } from "lodash";
// import {
//   getChapters,
//   getSessionsByChapter,
// } from "../services/recordedSessionsService";

// const RecordedClassesSection = ({
//   selectedCourseId,
//   selectedLanguage,
//   selectedClass,
// }) => {
//   const [view, setView] = useState("chapters"); // 'chapters' or 'sessions'
//   const [selectedChapter, setSelectedChapter] = useState(null);
//   const [chapters, setChapters] = useState([]);
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
  
//   // Single search query for filtering
//   const [searchQuery, setSearchQuery] = useState("");

//   // Optimized debounced search
//   const debouncedFetchChapters = useCallback(
//     debounce(async (query) => {
//       try {
//         setLoading(true);
//         setError(null);

//         const filters = {
//           class: selectedClass,
//           language: selectedLanguage,
//           courseid: selectedCourseId,
//           searchQuery: query,
//         };

//         const chaptersData = await getChapters(filters);
        
//         if (chaptersData.success) {
//           setChapters(chaptersData.chapters);
//         } else {
//           setChapters(chaptersData);
//         }
//       } catch (err) {
//         console.error("Error fetching chapters:", err);
//         setError("Failed to load chapters. Please try again later.");
//         setChapters([]);
//       } finally {
//         setLoading(false);
//       }
//     }, 300),
//     [selectedCourseId, selectedLanguage, selectedClass]
//   );

//   // Fetch chapters when component mounts or enrollment changes
//   useEffect(() => {
//     debouncedFetchChapters(searchQuery);
    
//     // Cleanup function to cancel debounced call
//     return () => {
//       debouncedFetchChapters.cancel();
//     };
//   }, [debouncedFetchChapters, searchQuery]);

//   const fetchSessionsByChapter = async (chapterId) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const sessionsData = await getSessionsByChapter(chapterId, {
//         class: selectedClass,
//         language: selectedLanguage,
//         courseid: selectedCourseId,
//       });
      
//       if (sessionsData.success) {
//         setSessions(sessionsData.sessions);
//       } else {
//         setSessions(sessionsData);
//       }
//     } catch (err) {
//       console.error("Error fetching sessions:", err);
//       setError("Failed to load sessions. Please try again later.");
//       setSessions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChapterClick = (chapter) => {
//     setSelectedChapter(chapter);
//     setView("sessions");
//     fetchSessionsByChapter(chapter._id);
//   };

//   const handleBackToChapters = () => {
//     setView("chapters");
//     setSelectedChapter(null);
//     setSessions([]);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Memoized utility functions
//   const getDifficultyColor = useMemo(() => {
//     return (difficulty) => {
//       switch (difficulty?.toLowerCase()) {
//         case 'beginner':
//           return 'bg-green-100 text-green-800 border-green-200';
//         case 'intermediate':
//           return 'bg-yellow-100 text-yellow-800 border-yellow-200';
//         case 'advanced':
//           return 'bg-red-100 text-red-800 border-red-200';
//         default:
//           return 'bg-gray-100 text-gray-800 border-gray-200';
//       }
//     };
//   }, []);

//   const getSubjectColor = useMemo(() => {
//     const colorMap = {
//       'History': 'bg-purple-100 text-purple-800 border-purple-200',
//       'Polity': 'bg-blue-100 text-blue-800 border-blue-200',
//       'Economy': 'bg-emerald-100 text-emerald-800 border-emerald-200',
//       'Geography': 'bg-orange-100 text-orange-800 border-orange-200',
//       'Science': 'bg-cyan-100 text-cyan-800 border-cyan-200',
//       'Mathematics': 'bg-pink-100 text-pink-800 border-pink-200',
//       'English': 'bg-indigo-100 text-indigo-800 border-indigo-200',
//       'General Knowledge': 'bg-teal-100 text-teal-800 border-teal-200',
//     };
    
//     return (subject) => colorMap[subject] || 'bg-gray-100 text-gray-800 border-gray-200';
//   }, []);

//   // Memoized chapters list to prevent unnecessary re-renders
//   const chaptersContent = useMemo(() => {
//     if (loading) {
//       return (
//         <div className="flex justify-center items-center py-20">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//         </div>
//       );
//     }

//     if (error) {
//       return (
//         <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
//           <svg className="w-12 h-12 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//           </svg>
//           <h3 className="text-lg font-medium text-red-800 mb-1">Error Loading Chapters</h3>
//           <p className="text-red-600">{error}</p>
//           <button 
//             onClick={() => debouncedFetchChapters(searchQuery)}
//             className="mt-3 inline-flex items-center px-4 py-2 border border-red-300 rounded-md text-sm font-medium text-red-700 bg-red-50 hover:bg-red-100 transition-colors"
//           >
//             Try Again
//           </button>
//         </div>
//       );
//     }

//     if (chapters.length === 0) {
//       return (
//         <div className="text-center py-16">
//           <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
//           </svg>
//           <h3 className="text-lg font-medium text-gray-900 mb-1">No Chapters Found</h3>
//           <p className="text-gray-600">
//             {searchQuery ? "Try adjusting your search query" : "No chapters available for the selected course"}
//           </p>
//         </div>
//       );
//     }

//     return (
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {chapters.map((chapter, index) => (
//           <motion.div
//             key={chapter._id}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: index * 0.1 }}
//             className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-gray-100"
//             onClick={() => handleChapterClick(chapter)}
//           >
//             <div className="relative overflow-hidden">
//               <img
//                 src={chapter.image || "/images/chapter-placeholder.jpg"}
//                 alt={chapter.title}
//                 className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
//               />
//               <div className="absolute top-3 right-3 flex flex-col gap-2">
//                 <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${getSubjectColor(chapter.subject)}`}>
//                   {chapter.subject}
//                 </span>
//                 {chapter.difficulty && (
//                   <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${getDifficultyColor(chapter.difficulty)}`}>
//                     {chapter.difficulty}
//                   </span>
//                 )}
//               </div>
//               <div className="absolute bottom-3 left-3 bg-black/70 text-white px-3 py-1 rounded-full text-xs font-medium">
//                 {chapter.classCount} Classes
//               </div>
//             </div>
            
//             <div className="p-5">
//               <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 min-h-[3.5rem]">
//                 {chapter.title}
//               </h3>
              
//               <p className="text-gray-600 text-sm mb-4 line-clamp-3 min-h-[4rem]">
//                 {chapter.description}
//               </p>
              
//               <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
//                 <div className="flex items-center gap-4">
//                   <div className="flex items-center">
//                     <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                     </svg>
//                     {chapter.totalDuration}
//                   </div>
//                   <div className="flex items-center">
//                     <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
//                     </svg>
//                     {chapter.classCount}
//                   </div>
//                 </div>
//               </div>
              
//               <div className="flex items-center justify-between">
//                 <div className="flex items-center text-indigo-600 font-medium text-sm">
//                   <span>View Classes</span>
//                 </div>
//                 <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                 </svg>
//               </div>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     );
//   }, [chapters, loading, error, searchQuery, getDifficultyColor, getSubjectColor, debouncedFetchChapters]);

//   // Memoized sessions list
//   const sessionsContent = useMemo(() => {
//     if (loading) {
//       return (
//         <div className="flex justify-center items-center py-20">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//         </div>
//       );
//     }

//     if (error) {
//       return (
//         <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
//           <h3 className="text-lg font-medium text-red-800 mb-1">Error Loading Sessions</h3>
//           <p className="text-red-600">{error}</p>
//         </div>
//       );
//     }

//     if (sessions.length === 0) {
//       return (
//         <div className="text-center py-16">
//           <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
//           </svg>
//           <h3 className="text-lg font-medium text-gray-900 mb-1">No Sessions Found</h3>
//           <p className="text-gray-600">No sessions available for this chapter</p>
//         </div>
//       );
//     }

//     return (
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {sessions.map((session, index) => (
//           <motion.div
//             key={session._id}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: index * 0.1 }}
//             className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
//           >
//             <div className="relative">
//               <img
//                 src={session.image || "/images/session-placeholder.jpg"}
//                 alt={session.title}
//                 className="w-full h-48 object-cover"
//               />
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
//                   <svg className="w-8 h-8 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
//                   </svg>
//                 </div>
//               </div>
//               <div className="absolute top-2 right-2 flex space-x-2">
//                 <span className={`text-xs font-medium px-2.5 py-0.5 rounded border ${getSubjectColor(session.subject)}`}>
//                   {session.subject}
//                 </span>
//                 {session.type && (
//                   <span className={`text-xs font-medium px-2.5 py-0.5 rounded ${
//                     session.type === "foundation" ? "bg-green-100 text-green-800 border-green-200" :
//                     session.type === "prelims" ? "bg-blue-100 text-blue-800 border-blue-200" :
//                     "bg-purple-100 text-purple-800 border-purple-200"
//                   }`}>
//                     {session.type.charAt(0).toUpperCase() + session.type.slice(1)}
//                   </span>
//                 )}
//               </div>
//               <div className="absolute bottom-2 left-2 bg-black/70 text-white text-xs font-medium px-2.5 py-0.5 rounded">
//                 {session.duration}
//               </div>
//             </div>
//             <div className="p-5">
//               <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
//                 {session.title}
//               </h3>
//               <p className="text-gray-600 text-sm mb-4 line-clamp-2">
//                 {session.description}
//               </p>
//               <div className="flex items-center mb-4">
//                 <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                 </svg>
//                 <p className="text-sm text-gray-700">{session.instructor}</p>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-xs text-gray-500">
//                   {session.date && new Date(session.date).toLocaleDateString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })}
//                 </span>
//                 <Link
//                   to={`/watch-session/${session._id}`}
//                   className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
//                 >
//                   <span>Watch</span>
//                   <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                   </svg>
//                 </Link>
//               </div>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     );
//   }, [sessions, loading, error, getSubjectColor]);

//   return (
//     <div className="mb-12">
//       <div className="flex items-center justify-between mb-6">
//         <div>
//           <h2 className="text-3xl font-bold text-gray-900 mb-2">
//             {view === "chapters" ? "Chapter Library" : selectedChapter?.title}
//           </h2>
//           <p className="text-lg text-gray-600">
//             {view === "chapters" 
//               ? "Explore chapters and access recorded sessions organized by topics"
//               : `${sessions.length} sessions available in this chapter`
//             }
//           </p>
//         </div>
        
//         {view === "sessions" && (
//           <button
//             onClick={handleBackToChapters}
//             className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
//           >
//             <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//             </svg>
//             Back to Chapters
//           </button>
//         )}
//       </div>

//       {/* Search Filter */}
//       {view === "chapters" && (
//         <div className="bg-gray-50 p-6 rounded-lg mb-8">
//           <div className="max-w-md">
//             <label htmlFor="search-filter" className="block text-sm font-medium text-gray-700 mb-2">
//               Search Chapters
//             </label>
//             <div className="relative">
//               <input
//                 type="text"
//                 id="search-filter"
//                 className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 pl-10 pr-4 py-2"
//                 placeholder="Search by title, subject, or description..."
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//               />
//               <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                 <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                 </svg>
//               </div>
//               {searchQuery && (
//                 <button
//                   onClick={() => setSearchQuery("")}
//                   className="absolute inset-y-0 right-0 flex items-center pr-3"
//                 >
//                   <svg className="w-4 h-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Content */}
//       <AnimatePresence mode="wait">
//         {view === "chapters" ? (
//           <motion.div
//             key="chapters"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.2 }}
//           >
//             {chaptersContent}
//           </motion.div>
//         ) : (
//           <motion.div
//             key="sessions"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.2 }}
//           >
//             {sessionsContent}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default RecordedClassesSection;
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { debounce } from "lodash";
import axios from "axios";
import { CONSTANTS } from "../constants/Constants";
import {
  getChapters,
} from "../services/recordedSessionsService";

const RecordedClassesSection = ({
  selectedCourseId,
  selectedLanguage,
  selectedClass,
}) => {
  const [view, setView] = useState("chapters"); // 'chapters' or 'sessions'
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Single search query for filtering
  const [searchQuery, setSearchQuery] = useState("");

  // Optimized debounced search - keep using Firestore for chapters
  const debouncedFetchChapters = useCallback(
    debounce(async (query) => {
      try {
        setLoading(true);
        setError(null);

        const filters = {
          class: selectedClass,
          language: selectedLanguage,
          courseid: selectedCourseId,
          searchQuery: query,
        };

        const chaptersData = await getChapters(filters);
        
        if (chaptersData.success) {
          setChapters(chaptersData.chapters);
        } else {
          setChapters(chaptersData);
        }
      } catch (err) {
        console.error("Error fetching chapters:", err);
        setError("Failed to load chapters. Please try again later.");
        setChapters([]);
      } finally {
        setLoading(false);
      }
    }, 300),
    [selectedCourseId, selectedLanguage, selectedClass]
  );

  // Fetch chapters when component mounts or enrollment changes
  useEffect(() => {
    debouncedFetchChapters(searchQuery);
    
    // Cleanup function to cancel debounced call
    return () => {
      debouncedFetchChapters.cancel();
    };
  }, [debouncedFetchChapters, searchQuery]);

  // NEW: Fetch sessions by chapter using API endpoint
  const fetchSessionsByChapter = async (chapter) => {
    try {
      setLoading(true);
      setError(null);

      const params = new URLSearchParams({
        chapterName: chapter.title, // Use chapter title as chapterName
        page: "1",
        limit: "50",
        sort: "newest",
        ...(selectedClass !== "all" && { class: selectedClass }),
        ...(selectedLanguage !== "all" && { language: selectedLanguage }),
        ...(selectedCourseId !== "all" && { courseid: selectedCourseId })
      });

      const response = await axios.get(
        `${CONSTANTS.APIURL}/api/recorded-sessions/chapters?${params}`
      );

      if (response.data.success) {
        setSessions(response.data.recordedSessions || []);
      } else {
        setSessions([]);
        setError("Failed to load sessions for this chapter");
      }
    } catch (err) {
      console.error("Error fetching sessions:", err);
      setError("Failed to load sessions. Please try again later.");
      setSessions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChapterClick = (chapter) => {
    setSelectedChapter(chapter);
    setView("sessions");
    fetchSessionsByChapter(chapter);
  };

  const handleBackToChapters = () => {
    setView("chapters");
    setSelectedChapter(null);
    setSessions([]);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Memoized utility functions
  const getDifficultyColor = useMemo(() => {
    return (difficulty) => {
      switch (difficulty?.toLowerCase()) {
        case 'beginner':
          return 'bg-green-100 text-green-800 border-green-200';
        case 'intermediate':
          return 'bg-yellow-100 text-yellow-800 border-yellow-200';
        case 'advanced':
          return 'bg-red-100 text-red-800 border-red-200';
        default:
          return 'bg-gray-100 text-gray-800 border-gray-200';
      }
    };
  }, []);

  const getSubjectColor = useMemo(() => {
    const colorMap = {
      'History': 'bg-purple-100 text-purple-800 border-purple-200',
      'Polity': 'bg-blue-100 text-blue-800 border-blue-200',
      'Economy': 'bg-emerald-100 text-emerald-800 border-emerald-200',
      'Geography': 'bg-orange-100 text-orange-800 border-orange-200',
      'Science': 'bg-cyan-100 text-cyan-800 border-cyan-200',
      'Mathematics': 'bg-pink-100 text-pink-800 border-pink-200',
      'English': 'bg-indigo-100 text-indigo-800 border-indigo-200',
      'General Knowledge': 'bg-teal-100 text-teal-800 border-teal-200',
    };
    
    return (subject) => colorMap[subject] || 'bg-gray-100 text-gray-800 border-gray-200';
  }, []);

  // Memoized chapters list to prevent unnecessary re-renders
  const chaptersContent = useMemo(() => {
    if (loading) {
      return (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <svg className="w-12 h-12 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-lg font-medium text-red-800 mb-1">Error Loading Chapters</h3>
          <p className="text-red-600">{error}</p>
          <button 
            onClick={() => debouncedFetchChapters(searchQuery)}
            className="mt-3 inline-flex items-center px-4 py-2 border border-red-300 rounded-md text-sm font-medium text-red-700 bg-red-50 hover:bg-red-100 transition-colors"
          >
            Try Again
          </button>
        </div>
      );
    }

    if (chapters.length === 0) {
      return (
        <div className="text-center py-16">
          <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No Chapters Found</h3>
          <p className="text-gray-600">
            {searchQuery ? "Try adjusting your search query" : "No chapters available for the selected course"}
          </p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {chapters.map((chapter, index) => (
          <motion.div
            key={chapter._id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border border-gray-100"
            onClick={() => handleChapterClick(chapter)}
          >
            <div className="relative overflow-hidden">
              <img
                src={chapter.image || "/images/chapter-placeholder.jpg"}
                alt={chapter.title}
                className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
              />
              <div className="absolute top-3 right-3 flex flex-col gap-2">
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${getSubjectColor(chapter.subject)}`}>
                  {chapter.subject}
                </span>
                {chapter.difficulty && (
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${getDifficultyColor(chapter.difficulty)}`}>
                    {chapter.difficulty}
                  </span>
                )}
              </div>
              <div className="absolute bottom-3 left-3 bg-black/70 text-white px-3 py-1 rounded-full text-xs font-medium">
                {chapter.classCount} Classes
              </div>
            </div>
            
            <div className="p-5">
              <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 min-h-[3.5rem]">
                {chapter.title}
              </h3>
              
              <p className="text-gray-600 text-sm mb-4 line-clamp-3 min-h-[4rem]">
                {chapter.description}
              </p>
              
              <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                <div className="flex items-center gap-4">
                  <div className="flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {chapter.totalDuration}
                  </div>
                  <div className="flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    {chapter.classCount}
                  </div>
                </div>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center text-indigo-600 font-medium text-sm">
                  <span>View Classes</span>
                </div>
                <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    );
  }, [chapters, loading, error, searchQuery, getDifficultyColor, getSubjectColor, debouncedFetchChapters]);

  // Memoized sessions list
  const sessionsContent = useMemo(() => {
    if (loading) {
      return (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <h3 className="text-lg font-medium text-red-800 mb-1">Error Loading Sessions</h3>
          <p className="text-red-600">{error}</p>
          <button 
            onClick={() => fetchSessionsByChapter(selectedChapter)}
            className="mt-3 inline-flex items-center px-4 py-2 border border-red-300 rounded-md text-sm font-medium text-red-700 bg-red-50 hover:bg-red-100 transition-colors"
          >
            Try Again
          </button>
        </div>
      );
    }

    if (sessions.length === 0) {
      return (
        <div className="text-center py-16">
          <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No Sessions Found</h3>
          <p className="text-gray-600">No sessions available for this chapter</p>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {sessions.map((session, index) => (
          <motion.div
            key={session._id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
          >
            <div className="relative">
              <img
                src={session.image || "/images/session-placeholder.jpg"}
                alt={session.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
                  <svg className="w-8 h-8 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M4 5h3v10H4V5zm12 0v10l-9-5 9-5z" />
                  </svg>
                </div>
              </div>
              <div className="absolute top-2 right-2 flex space-x-2">
                <span className={`text-xs font-medium px-2.5 py-0.5 rounded border ${getSubjectColor(session.subject)}`}>
                  {session.subject}
                </span>
                {session.type && (
                  <span className={`text-xs font-medium px-2.5 py-0.5 rounded ${
                    session.type === "foundation" ? "bg-green-100 text-green-800 border-green-200" :
                    session.type === "prelims" ? "bg-blue-100 text-blue-800 border-blue-200" :
                    "bg-purple-100 text-purple-800 border-purple-200"
                  }`}>
                    {session.type.charAt(0).toUpperCase() + session.type.slice(1)}
                  </span>
                )}
              </div>
              <div className="absolute bottom-2 left-2 bg-black/70 text-white text-xs font-medium px-2.5 py-0.5 rounded">
                {session.duration}
              </div>
            </div>
            <div className="p-5">
              <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                {session.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                {session.description}
              </p>
              <div className="flex items-center mb-4">
                <svg className="w-4 h-4 mr-1 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <p className="text-sm text-gray-700">{session.instructor}</p>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500">
                  {session.date && new Date(session.date).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </span>
                <Link
                  to={`/watch-session/${session._id}`}
                  className="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
                >
                  <span>Watch</span>
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    );
  }, [sessions, loading, error, getSubjectColor, selectedChapter]);

  return (
    <div className="mb-12">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            {view === "chapters" ? "Chapter Library" : selectedChapter?.title}
          </h2>
          <p className="text-lg text-gray-600">
            {view === "chapters" 
              ? "Explore chapters and access recorded sessions organized by topics"
              : `${sessions.length} sessions available in this chapter`
            }
          </p>
        </div>
        
        {view === "sessions" && (
          <button
            onClick={handleBackToChapters}
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Chapters
          </button>
        )}
      </div>

      {/* Search Filter */}
      {view === "chapters" && (
        <div className="bg-gray-50 p-6 rounded-lg mb-8">
          <div className="max-w-md">
            <label htmlFor="search-filter" className="block text-sm font-medium text-gray-700 mb-2">
              Search Chapters
            </label>
            <div className="relative">
              <input
                type="text"
                id="search-filter"
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 pl-10 pr-4 py-2"
                placeholder="Search by title, subject, or description..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute inset-y-0 right-0 flex items-center pr-3"
                >
                  <svg className="w-4 h-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Content */}
      <AnimatePresence mode="wait">
        {view === "chapters" ? (
          <motion.div
            key="chapters"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {chaptersContent}
          </motion.div>
        ) : (
          <motion.div
            key="sessions"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {sessionsContent}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RecordedClassesSection;